<template>
<div class="flex flex-row min-h-screen">
  <nav class="flex flex-1 flex-col max-h-screen max-w-xxs bg-blue-darkest shadow sticky pin-t">
    <div class="logo bg-blue text-white py-4 text-center">PPS</div>
    <router-link :to="{ name: 'dashboard' }">Sandford dashboard</router-link>
    <router-link :to="{ name: 'installations' }">Installations</router-link>
    <ul>
      <li>
        <router-link :to="{ name: `addInstallation` }">Add new</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'uploadInstallations' }">Upload many (CSV)</router-link>
      </li>
    </ul>
  </nav>

  <div class="flex-1 flex flex-col min-h-screen">
    <div class="bg-white z-10 sticky pin-t py-4 shadow z-10">
      <div class="container mx-auto px-6 text-right">
        {{ currentUserName }}
        <router-link to="/logout" class="logout">
          Log out
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.7 12.7">
            <path d="M7 1.4H2.2v9.9h5v-.7H2.8V2h4.3z"></path>
            <path d="M4.2 5.6h5L7 3.6l.7-.8 3.5 3.5L7.8 10 7 9.2 9 7H4.3z"></path>
          </svg>
        </router-link>
      </div>
    </div>

    <div class="bg-grey-lightest flex-1 px-6 pt-6 pb-12">
      <router-view />
    </div>
  </div>
  <vue-snotify></vue-snotify>
</div>
</template>

<script>
import Vue from 'vue';
import {
  mapGetters
} from 'vuex';

import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-snotify/styles/material.css';

import Multiselect from 'vue-multiselect';
import Snotify from 'vue-snotify'; // 1. Import Snotify

Vue.component('multiselect', Multiselect);
Vue.use(Snotify);

export default {
  name: 'admin',
  computed: {
    ...mapGetters({
      currentUserName: 'currentUserName'
    }),
    route() {
      return this.$route.name;
    }
  }
};
</script>

<style>
nav a {
  @apply block;
  @apply font-bold;
  @apply text-grey-lightest;
  @apply text-xs;
  @apply uppercase;
  @apply text-grey-dark;
  @apply relative;
  @apply px-4;
  @apply py-4;
  @apply no-underline;
  transition: background 0.3s ease-out;
}

nav a::before {
  @apply bg-blue-dark;
  bottom: 0;
  content: '';
  left: 0;
  opacity: 0.4;
  position: absolute;
  top: 0;
  width: 5px;
  transform: scaleX(0);
  transition: all 0.1s ease-in;
}

nav a::after {
  @apply bg-grey-darkest;
  background: linear-gradient(to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(61, 72, 82, 0) 6%,
    rgba(61, 72, 82, 1) 100%);
  bottom: 0;
  content: '';
  left: 0;
  height: 1px;
  opacity: 0.7;
  position: absolute;
  right: 0;
}

nav a:hover,
nav a:focus,
nav a.router-link-active {
  @apply text-grey-light;
}

nav a:hover::before,
nav a:focus::before {
  opacity: 0.4;
  transform: scaleX(0.5);
}

nav a.router-link-active::before {
  opacity: 0.8;
  transform: scaleX(1);
}

nav ul {
  @apply m-0;
  @apply p-0;
}

nav ul > li {
  list-style: none;
  @apply pl-2;
}

.logout {
  @apply no-underline;
}

.logout svg {
  @apply fill-current;
  @apply inline-block;
  @apply h-5;
  @apply w-5;
  @apply align-middle;
}

.content {
  @apply bg-white;
  @apply mx-auto;
  @apply pt-6;
  @apply px-6;
  @apply py-8;
  @apply relative;
  @apply rounded;
  @apply shadow;
}

.subheading {
  @apply font-normal;
  @apply text-xl;
  @apply leading-loose;
  @apply py-0;
  @apply m-0;
  @apply mt-6;
  @apply mb-1;
}

.small-heading {
  @apply font-medium;
  @apply text-lg;
  @apply leading-loose;
  @apply py-0;
  @apply m-0;
  @apply mb-4;
}

p {
  @apply mb-4;
  @apply pb-0;
}

.styled-table {
  @apply border-collapse;
  @apply table-auto;
  @apply w-full;
}

.styled-table tr {
  @apply border-grey-light;
  @apply border-b;
}

.styled-table tbody tr {
  transition: background 0.2s ease-out;
}

.styled-table tbody tr:last-child {
  @apply border-b-0;
}

.styled-table tbody tr:hover {
  @apply bg-grey-lightest;
}

.styled-table th {
  @apply capitalize;
  @apply text-sm;
  @apply text-grey;
  @apply font-bold;
  @apply text-left;
}

.styled-table th,
.styled-table td {
  @apply py-3;
  @apply pr-4;
  @apply align-top;
}

.styled-table th:last-child,
.styled-table td:last-child {
  @apply pr-0;
}

.hint {
  @apply text-grey-darker;
  @apply italic;
  @apply text-xs;
}

hr {
  @apply border-t;
  @apply border-grey-light;
  @apply mb-6;
  @apply mt-8;
  @apply -mx-6;
}
</style>
